<div class="row">
  <div class="card col-md-12 overflow-auto vh-100">
    <div class="col-md-12">
      <div class="col-md-12 col-xs-12">
        <ag-grid-angular
          class="ag-theme-alpine"
          [gridOptions]="gridOptions"
          (gridReady)="gridSetting($event)"
          [columnDefs]="columnDefs"
          [rowData]="notMapped"
          [domLayout]="'autoHeight'"
          [pagination]= "true"
          [paginationPageSize]="10"
          [paginationPageSizeSelector]="[10,20,30]"
          [enableCellTextSelection]="true"
          >
        </ag-grid-angular>
      </div>
      @if (showDropDown) {
        <div class="form-group col-md-8 mt-3">
          <div class="d-flex align-items-center gap-2">
            <div class="flex-grow-1">
              <app-material-organisation-selector
                id="organisation"
                class="pg-component w-100"
                [(ngModel)]="organisation"
                [organisationLanguage]="'fa'"
                name="organisation"
                [organisations]="organisations"
                [required]="true">
              </app-material-organisation-selector>
            </div>
            <app-material-pg-button
              name="save"
              (clicked)="saveMapped(kantarOrganisation)"
              label="Save">
            </app-material-pg-button>
          </div>
        </div>
      }
      </div>
    </div>
  </div>
